import React from 'react';
import { connect } from 'react-redux';
import { reject, map } from 'lodash/fp';
import * as selectors from 'selectors/pathBuilder';
import { toggleEditingUIElementByName } from 'actions/pathBuilder';
import * as taggingActions from 'actions/pathBuilder/tagging';
import { Icon } from 'ui';
import ContentTagging from 'components/shared/ContentTagging';
import InfoTooltip from 'components/shared/InfoTooltip';
import Section, { SectionHeader } from './Section';

const filterSuggestions = taggings => suggestions => {
  const selectedIds = map('tag.id', taggings);
  return reject(({ id }) => selectedIds.includes(id), suggestions);
};

const PathTagging = ({
  taggings,
  editingTaggings,
  toggleEditing,
  onCreateTagging,
  onRemoveTagging,
  onTaggingAllContent,
  isArchived,
}) => {
  const hasTags = taggings.length >= 1;
  const showEditButton = !isArchived && !editingTaggings && hasTags;
  return (
    <Section>
      <SectionHeader className="d-f jc-sb">
        <span>
          <span className="mr-4">Tags</span>
          <InfoTooltip tooltip="Admins can edit the available tags through the gear menu above" />
        </span>
        {showEditButton && (
          <button
            type="button"
            className="u-linkBtn fz-base fw-n"
            onClick={toggleEditing}
          >
            <Icon name="edit" className="mr-4" />
            Edit
          </button>
        )}
      </SectionHeader>
      <ContentTagging
        editing={editingTaggings}
        viewOnly={isArchived}
        toggleEditing={toggleEditing}
        taggings={taggings}
        tagsPath="/tags"
        queryParam="q"
        mapResponseToSuggestions={response => response.tags}
        filterSuggestions={filterSuggestions(taggings)}
        getTag={tagging => tagging.tag}
        getSuggestionValue={suggestion => suggestion.name}
        onCreateTagging={onCreateTagging}
        tagOptions={[
          {
            label: 'Remove this tag',
            icon: 'delete',
            onClick: onRemoveTagging,
          },
          {
            label: 'Tag all of this Path’s Lessons',
            icon: 'tags',
            onClick: onTaggingAllContent,
          },
        ]}
      />
    </Section>
  );
};

const UI_STATE_KEY = 'taggings';

const mapStateToProps = ({ pathBuilder }) => ({
  taggings: pathBuilder.taggings,
  editingTaggings: selectors.isEditingUIElementByName(
    pathBuilder,
    UI_STATE_KEY,
  ),
  isArchived: selectors.isArchived(pathBuilder),
});

const mapDispatchToProps = dispatch => ({
  onCreateTagging(tag) {
    dispatch(taggingActions.createTagging(tag));
  },
  onRemoveTagging(tagging) {
    dispatch(taggingActions.removeTagging(tagging));
  },
  onTaggingAllContent(tagging) {
    dispatch(taggingActions.tagAllContent(tagging));
  },
  toggleEditing() {
    dispatch(toggleEditingUIElementByName(UI_STATE_KEY));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PathTagging);
